import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { CheckCircle2 } from "lucide-react";

// Thank you page — Spanish only (per requirements).
export default function ThankYou() {
  return (
    <div className="thankyou-page" data-testid="thankyou-page">
      <Helmet>
        <html lang="es" />
        <title>Gracias | Ronavirexa</title>
        <meta name="description" content="Recibimos tu consulta. Te respondemos por correo electrónico a la brevedad." />
      </Helmet>
      <div className="thankyou-inner">
        <div className="thankyou-icon"><CheckCircle2 size={48} /></div>
        <span className="eyebrow">Consulta recibida</span>
        <h1 className="h-display thankyou-title">¡Gracias por escribirnos!</h1>
        <p className="thankyou-body">
          Recibimos tu mensaje. Nuestro equipo lo revisará y te responderá por correo electrónico en las próximas horas hábiles.
          Mientras tanto, podés seguir recorriendo la información publicada sobre proyectos de crowdlending inmobiliario en Argentina.
        </p>
        <p className="thankyou-body">
          Si tu consulta es urgente, escribinos directamente a <a href="mailto:hola@ronavirexa.com" className="inline-link">hola@ronavirexa.com</a> o llamanos al <a href="tel:+541148920415" className="inline-link">+54 11 4892-0415</a>.
        </p>
        <Link to="/" className="btn btn-solid thankyou-cta" data-testid="thankyou-back-home">
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
